

















import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import Velocity from "velocity-animate";

@Component
export default class LiveStreamingCustomOverlay extends Vue {

  @Prop() useCustomOverlay!: boolean;
  @Prop() image!: string;


  /* Emit Events */
  @Emit('click-close')
  onClickClose () {};

  @Emit('show')
  emitShow () {}

  @Emit('hide')
  emitHide () {}


  get overlayStyle (): any {
    return {
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
      backgroundImage: `url(${this.image})`
    }
  }


  /* Custom Transition Hook */
  beforeEnter ($el: HTMLDivElement): void {
    $el.style.opacity = '0';
  }

  enter ($el: HTMLDivElement, done: Function): void {
    Velocity($el, {
      opacity: [1, 0]
    }, {
      delay: 600,
      duration: 300,
      easing: 'linear',
      complete: () => {
        this.emitShow();
        done();
      }
    });
  }

  beforeLeave ($el: HTMLDivElement): void {
    $el.velocity('stop', true);
  }

  leave ($el: HTMLDivElement, done: Function): void {
    Velocity($el, {
      opacity: [0, 1]
    }, {
      duration: 180,
      easing: 'linear',
      complete: () => {
        this.emitHide();
        done();
      }
    });
  }

}
